import { Scope } from '@unform/core'
import { Alert } from '@vtex/shoreline'

import Panel from '~/components/Panel'
import { FormGroup, InputMoney, Label } from '~/components/unform'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

const DailyCostScope: React.FC = () => {
  const { t } = useAPPTranslation()

  return (
    <Panel title={t('rm:DailyCostScope.Panel.title')}>
      <Scope path="settings">
        <FormGroup>
          <Label
            htmlFor="daily_cost"
            isRequired
            text={t('rm:DailyCostScope.label')}
          />

          <InputMoney id="daily_cost" name="daily_cost" />

          <Alert variant="informational">
            {t('rm:DailyCostScope.alertoInfo')}
          </Alert>
        </FormGroup>
      </Scope>
    </Panel>
  )
}

export default DailyCostScope
